/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, count: NonNullable<unknown> }} Coaching_Inactive_SummaryInputs */

const en_us2_coaching_inactive_summary = /** @type {(inputs: Coaching_Inactive_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not trained for ${i?.days} days or more: ${i?.count}`)
};

const pt_br2_coaching_inactive_summary = /** @type {(inputs: Coaching_Inactive_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem treinar há ${i?.days} dias ou mais: ${i?.count}`)
};

const pt_pt2_coaching_inactive_summary = /** @type {(inputs: Coaching_Inactive_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem treinar há ${i?.days} dias ou mais: ${i?.count}`)
};

/** @type {(inputs: Coaching_Inactive_SummaryInputs) => LocalizedString} */
const es_419_coaching_inactive_summary = en_us2_coaching_inactive_summary;

/** @type {(inputs: Coaching_Inactive_SummaryInputs) => LocalizedString} */
const fr_fr2_coaching_inactive_summary = en_us2_coaching_inactive_summary;

/** @type {(inputs: Coaching_Inactive_SummaryInputs) => LocalizedString} */
const de_de2_coaching_inactive_summary = en_us2_coaching_inactive_summary;

/** @type {(inputs: Coaching_Inactive_SummaryInputs) => LocalizedString} */
const it_it2_coaching_inactive_summary = en_us2_coaching_inactive_summary;

/**
* | output |
* | --- |
* | "Not trained for {days} days or more: {count}" |
*
* @param {Coaching_Inactive_SummaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_inactive_summary = /** @type {((inputs: Coaching_Inactive_SummaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Inactive_SummaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_inactive_summary(inputs)
	if (locale === "es-419") return es_419_coaching_inactive_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_inactive_summary(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_inactive_summary(inputs)
	if (locale === "de-DE") return de_de2_coaching_inactive_summary(inputs)
	if (locale === "it-IT") return it_it2_coaching_inactive_summary(inputs)
	return en_us2_coaching_inactive_summary(inputs)
});
export { coaching_inactive_summary as "coaching.inactive_summary" }